import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import SearchIcon from "../images/search-icon.png";
import CloseIcon from "../images/white-close-icon.png";

const ShiftSelect = ({ value = [], onChange }) => {
  const data = ["Days", "Nights", "Mids"];

  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  // Filter based on search
  const filteredData = data.filter((item) =>
    item.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleSelect = (item) => {
    let updated;
    if (value.includes(item)) {
      updated = value.filter((i) => i !== item);
    } else {
      updated = [...value, item];
    }
    onChange(updated);
  };

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="multi-level-select" ref={dropdownRef}>
      {/* Box */}
      <div className="mls-input-box" onClick={() => setIsOpen(!isOpen)}>
        <span className="mls-placeholder">
          {value.length > 0 ? `${value.length} selected` : "Shift"}
        </span>
        <FaChevronDown className={`mls-chevron ${isOpen ? "open" : ""}`} />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="mls-dropdown">
          <div className="shift-search-bar">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <img src={SearchIcon} alt="" />
          </div>
          <ul className="mls-menu-list">
            {filteredData.map((item, idx) => (
              <li key={idx} className="mls-menu-item">
                <label>
                  <input
                    type="checkbox"
                    checked={value.includes(item)}
                    onChange={() => toggleSelect(item)}
                  />
                  <span>{item}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Tags */}
      {value.length > 0 && (
        <div className="shift-selected-tags">
          <div className="selected-tags">
            {value.map((item) => (
              <span className="tag" key={item}>
                {item}
                <img
                  className="mls-close-icon"
                  onClick={() => toggleSelect(item)}
                  src={CloseIcon}
                  alt="close"
                />
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShiftSelect;
